import { generateId } from "helpers/functions";
import { ActionTypeReducer, GenStateType, NestedKeys } from "helpers/types";
import { Project } from "models/project_type";
import { ColumnStatusId, CreateTaskCard, TaskCard } from "models/tasks_type";
import { UserModelGet } from "models/user_model";

type StateType = {
    loading: boolean;
    loggedUser: UserModelGet;
    tableList: Project[];
    users: UserModelGet[];
    projectSelected: Project;
    tasksList: TaskCard[];
    showTaskForm: boolean;
    taskForm: CreateTaskCard;
    taskFormFieldsError: Partial<Record<NestedKeys<CreateTaskCard>, string>>;
}

type ActionType = GenStateType<StateType>;

const initialState: StateType = {
    loading: false,
    loggedUser: null,
    tableList: [],
    users: [],
    projectSelected: null,
    tasksList: [],
    showTaskForm: false,
    taskForm: {
        code: generateId(),
        titulo: '',
        dataCriacao: new Date(),
        dataEstimativa: new Date(),
        descricao: '',
        projetoId: 0,
        status: ColumnStatusId.PENDING,
        userCriadorId: '',
        userResponsavelId: '',
    },
    taskFormFieldsError: {
        titulo: '',
        descricao: '',
        dataEstimativa: '',
        userResponsavelId: '',
        status: '',
    },
}

const reducer = (state: StateType, action: ActionTypeReducer<ActionType>) => {
    switch (action.type) {
        case 'setLoading':
            return { ...state, loading: action.payload };
        case 'setLoggedUser':
            return { ...state, loggedUser: action.payload };
        case 'setTableList':
            return { ...state, tableList: action.payload };
        case 'setUsers':
            return { ...state, users: action.payload };
        case 'setProjectSelected':
            return { ...state, projectSelected: action.payload };
        case 'setTasksList':
            return { ...state, tasksList: action.payload };
        case 'setTaskForm':
            return { ...state, taskForm: action.payload };
        case 'setTaskFormFieldsError':
            return { ...state, taskFormFieldsError: action.payload };
        case 'setShowTaskForm':
            return { ...state, showTaskForm: action.payload };
        default:
            return state;
    }
}

export { initialState, reducer };